module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sprouter-detail"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('img', {
    class: {
      'img-fix': _vm.isPhotoPosFix
    },
    attrs: {
      "src": _vm.photo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "name-container"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_vm._v(_vm._s(_vm.position))])]), _vm._v(" "), _c('div', {
    staticClass: "article",
    domProps: {
      "innerHTML": _vm._s(_vm.article)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-06c71610"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sectionTalking/SprouterDetail.vue
// module id = 663
// module chunks = 0